'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

const Refresher = ({ revalidate = 5 }) => {
  // const [countdown, setCountdown] = useState(revalidate);
  const router = useRouter()

  useEffect(() => {
    const timer = setInterval(() => {
      router.refresh()
    }, revalidate * 1000)

    return () => clearInterval(timer)
  }, [router, revalidate])
  return null
  // return (
  // 	<div className="flex items-center justify-center p-4 bg-gray-100 rounded-lg shadow-sm">
  // 		<span className="text-sm font-semibold text-gray-700">
  // 			Refreshing in: {countdown} seconds
  // 		</span>
  // 	</div>
  // );
}

export default Refresher
